module.exports = __webpack_public_path__ + "img/healthProMobile3.bb892d77.png";